import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateCountryAccessMutation } from "../graphql/mutations";
import type {
  CreateCountryAccessMutationType,
  CreateCountryAccessMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateCountryAccessMutation = (
  options?: MutationHookOptions<
    CreateCountryAccessMutationType,
    CreateCountryAccessMutationVariablesType
  >
) => {
  return useMutation<
    CreateCountryAccessMutationType,
    CreateCountryAccessMutationVariablesType
  >(CreateCountryAccessMutation, options);
};
